import { ImageComponent } from './Image';
export default ImageComponent;
